// components/SignupCheck.tsx
import React, { useState, useEffect } from "react";
//import axios from "axios";
import axios from 'utils/axiosInstance';
import getRootData from 'utils/getRootData';
import { UserInfo } from 'types/user_info';
import { Bootpay } from '@bootpay/client-js';
import { useSearchParams } from 'react-router-dom';

const VITE_BOOTPAY_JAVASCRIPT_KEY = import.meta.env.VITE_BOOTPAY_JAVASCRIPT_KEY;

type Status = "idle" | "checking" | "not_found" | "found" | "need_auth";
type Tab = "name_check" | "danal_auth";

interface RootData {
  userInfo: UserInfo;
}

export default function SignupCheck() {
  const [searchParams] = useSearchParams();
  const { userInfo } = getRootData<RootData>() ?? { userInfo: null };
  const paramsTab = searchParams.get('tab');
  const isValidTab = (value: string): value is Tab =>
    value === "name_check" || value === "danal_auth";

  const [tab, setTab] = useState<Tab>(paramsTab && isValidTab(paramsTab) ? paramsTab : "name_check");
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [status, setStatus] = useState<Status>("idle");
  const [message, setMessage] = useState("");

  const handleCheck = async () => {
    setStatus("checking");
    try {
      // const res = await axios.post("/api/check_signup", { name, phone });
      // const { result } = res.data;

      const result = 'need_auth';

      if (result === "found") {
        setStatus("found");
        setMessage("✅ 가입된 사용자입니다.");
      } else if (result === "need_auth") {
        setStatus("need_auth");
        setTab("danal_auth");
        setMessage("전화번호가 변경된 것 같아요. 본인인증을 진행해주세요.");
      } else {
        setStatus("not_found");
        setMessage("가입 이력이 없습니다. 회원가입이 필요합니다.");
      }
    } catch (e) {
      setMessage("서버 오류가 발생했습니다.");
      setStatus("idle");
    }
  };

  const handleCertification = async () => {
    const baseUrl = `${window.location.protocol}//${window.location.host}`;

    try {
      const response = await Bootpay.requestAuthentication({
        application_id: VITE_BOOTPAY_JAVASCRIPT_KEY,
        pg: 'danal',
        order_name: '본인인증',
        authentication_id: '가맹점에서 부여한 고유 본인인증 ID',
        user: {
          username: '홍길동',
          phone: '01000000000'
        },
        show_agree_window: 1,
        redirect_url: baseUrl + '/signup_check?tab=danal_auth&finished=true'
      })
      switch (response.event) {
        case 'done':
          // 본인인증 완료, 본인인증의 경우 성공시 done 이벤트만 받는다 (만약 분리승인 옵션을 줬을 경우 confirm 도 수신하게 됨)
          console.log(response.data)
          // 결제 완료 처리
          break
      }

    } catch (e) {
      // 결제 진행중 오류 발생
      // e.error_code - 부트페이 오류 코드
      // e.pg_error_code - PG 오류 코드
      // e.message - 오류 내용
      console.log(e.message)
      switch (e.event) {
        case 'cancel':
          // 사용자가 결제창을 닫을때 호출
          console.log(e.message);
          break
        case 'error':
          // 결제 승인 중 오류 발생시 호출
          console.log(e.error_code);
          break
      }
    }
  };

  const handleDanalAuth = () => {
    // 다날 본인인증 호출 예시
    //window.location.href = "/payment/identification"; // 또는 팝업/SDK 사용
    handleCertification();
  };

  const showDanalAuthButton = () => {
    setStatus("need_auth");
  }

  const redirectToLogin = () => {
    window.location.href = "/users/sign_in?return_url=" + document.referrer;
  };

  
  // console.log('userInfo', userInfo);
  // console.log('userInfo?.userId', userInfo?.userId);

  if (!userInfo?.userId) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-amber-50 to-orange-50 flex items-center justify-center px-4">
        <div className="max-w-lg mx-auto bg-white rounded-2xl shadow-xl overflow-hidden">
          {/* Header Section with Icon */}
          <div className="bg-gradient-to-r from-amber-500 to-orange-500 px-8 py-12 text-center">
            <div className="w-20 h-20 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-4">
              <svg className="w-12 h-12 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
              </svg>
            </div>
            <h1 className="text-2xl font-bold text-white mb-2">황금독서클럽에 오신 것을 환영합니다</h1>
            <p className="text-white/90 text-lg">로그인하고 특별한 독서 여정을 시작하세요</p>
          </div>

          {/* Content Section */}
          <div className="px-8 py-8 space-y-6">
            {/* Main Message */}
            <div className="text-center">
              <div className="w-16 h-16 bg-amber-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <svg className="w-8 h-8 text-amber-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                </svg>
              </div>
              <h2 className="text-xl font-semibold text-gray-800 mb-2">로그인이 필요합니다</h2>
              <p className="text-gray-600 leading-relaxed">
                멤버십 서비스를 이용하시려면 먼저 회원가입 또는 로그인을 해주세요.
              </p>
            </div>

            {/* Features */}
            <div className="bg-gradient-to-r from-blue-50 to-indigo-50 rounded-xl p-6">
              <h3 className="font-semibold text-gray-800 mb-3 flex items-center">
                <svg className="w-5 h-5 text-blue-600 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
                간편한 소셜 로그인
              </h3>
              <p className="text-sm text-gray-600 leading-relaxed">
                황금독서클럽은 상생방송 통합로그인(SSO)를 사용합니다.
                <span className="font-medium text-blue-600"> 네이버, 구글, 카카오</span>를 통한
                간편한 회원가입/로그인이 가능합니다.
              </p>
            </div>

            {/* Social Login Icons Preview */}
            {/* <div className="flex justify-center space-x-4">
              <div className="w-12 h-12 bg-green-500 rounded-lg flex items-center justify-center">
                <span className="text-white font-bold text-sm">N</span>
              </div>
              <div className="w-12 h-12 bg-red-500 rounded-lg flex items-center justify-center">
                <span className="text-white font-bold text-sm">G</span>
              </div>
              <div className="w-12 h-12 bg-yellow-400 rounded-lg flex items-center justify-center">
                <span className="text-gray-800 font-bold text-sm">K</span>
              </div>
            </div> */}

            {/* CTA Button */}
            <button
              onClick={redirectToLogin}
              className="w-full bg-gradient-to-r from-amber-500 to-orange-500 hover:from-amber-600 hover:to-orange-600 text-white font-semibold py-4 px-6 rounded-xl transition-all duration-200 transform hover:scale-105 shadow-lg hover:shadow-xl"
            >
              <span className="flex items-center justify-center">
                <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 16l-4-4m0 0l4-4m-4 4h14m-5 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h7a3 3 0 013 3v1" />
                </svg>
                회원가입 / 로그인 하기
              </span>
            </button>

            {/* Additional Info */}
            <div className="text-center pt-4">
              <p className="text-xs text-gray-500">
                이미 계정이 있으시다면 바로 로그인하세요 🎉
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="max-w-md mx-auto p-6 bg-white shadow rounded-xl space-y-4 my-40">
      <div>로그인된 상태입니다.</div>
    </div>
  );

  return (
    <div className="max-w-md mx-auto p-6 bg-white shadow rounded-xl space-y-4">
      <div className="tabs tabs-boxed">
        <a
          className={`tab ${tab === "name_check" ? "tab-active" : ""}`}
          onClick={() => setTab("name_check")}
        >
          이름/전화번호 인증
        </a>
        <a
          className={`tab ${tab === "danal_auth" ? "tab-active" : ""}`}
          onClick={() => setTab("danal_auth")}
        >
          본인인증 (다날)
        </a>
      </div>

      {tab === "name_check" && (
        <>
          <h2 className="text-xl font-bold">가입 여부 확인</h2>

          <input
            type="text"
            placeholder="이름"
            value={name}
            onChange={(e) => setName(e.target.value)}
            className="input input-bordered w-full"
          />

          <input
            type="tel"
            placeholder="전화번호 (예: 01012345678)"
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
            className="input input-bordered w-full"
          />

          <button onClick={handleCheck} className="btn btn-primary w-full" disabled={status === "checking"}>
            {status === "checking" ? "확인 중..." : "가입 여부 확인"}
          </button>

          {message && <div className="alert alert-info">{message}</div>}
        </>
      )}

      {tab === "danal_auth" && (
        <>
          <h2 className="text-xl font-bold">본인인증 (다날)</h2>
          <p>이름/전화번호 인증에 실패했거나 정보가 변경된 경우, 본인인증을 진행해주세요.</p>

          <button onClick={handleDanalAuth} className="btn btn-outline btn-secondary w-full">
            다날 본인인증 시작
          </button>

          {message && <div className="alert alert-info">{message}</div>}
        </>
      )}
    </div>
  );
}
